import { formatDistanceToNowStrict } from 'date-fns'
import { useQueryOrderEngagementETA } from '@/features/shop/services/Orders/queries'
import { getHourMinutePeriodWithTimezone } from '@/features/shared/utils/date'
import { useDefaultShoppingAddress } from '@/features/account/services/Addresses/hooks'
import { type OrderStatus } from '@/features/shop/services/Orders/types'

type OrderETARangeProps = {
  orderId: number
  isPickup: boolean
  orderStatus: OrderStatus
}
export const useOrderETARange = ({ orderId, orderStatus, isPickup }: OrderETARangeProps) => {
  const isRealTimeETA = orderStatus === 'processed' && !isPickup

  const { data, isError, isFetching } = useQueryOrderEngagementETA(orderId, isRealTimeETA)
  const { timezone } = useDefaultShoppingAddress()
  const hasErrorOrFetching = isError || isFetching

  const eta_range = data?.destination_waypoint.eta_range

  const eta = data?.destination_waypoint.eta
  const shopperEta = eta ? `Delivery in ${formatDistanceToNowStrict(eta)}` : ''
  const shopperCoordinates = data
    ? {
        lat: data.shopper_location.coordinates.latitude,
        lng: data.shopper_location.coordinates.longitude,
      }
    : undefined

  const sourceCoordinates = data
    ? {
        lat: data.source_waypoint.coordinates.latitude,
        lng: data.source_waypoint.coordinates.longitude,
      }
    : undefined

  const destinationCoordinates = data
    ? {
        lat: data.destination_waypoint.coordinates.latitude,
        lng: data.destination_waypoint.coordinates.longitude,
      }
    : undefined

  const routeToBeTravelled = data?.future_route ?? []

  const routeTravelled = data?.travelled_route ?? []

  const etaStart = getHourMinutePeriodWithTimezone(eta_range?.eta_range_start || '', timezone)
  const etaEnd = getHourMinutePeriodWithTimezone(eta_range?.eta_range_end || '', timezone)

  return {
    etaStart,
    etaEnd,
    shopperEta,
    isRealTimeETA,
    isError,
    isFetching,
    hasErrorOrFetching,
    sourceCoordinates,
    shopperCoordinates,
    destinationCoordinates,
    routeToBeTravelled,
    routeTravelled,
  }
}
